import { bugsnag } from 'shared/utils/services/bugsnag';

export const fireTiktokTracker = (type: string, params = {}, email) => {
  // NOTE: Do not fire if tiktok is undefined and one trust advertising category is blocked
  if (!window?.ttq || !window?.OptanonActiveGroups?.includes('C0004')) return;

  try {
    if (email) {
      window?.ttq?.identify({ email });
    }

    window?.ttq?.track(type, params);
  } catch (error) {
    const errorMessage = (error as Error)?.message;

    bugsnag(`Error firing tiktok tracker: ${errorMessage}`, {
      context: 'tracking',
      severity: 'warning',
    });
  }
};

export const fireTiktokPDPView = ({ contentCategory, contentId, contentName, price }, email) => {
  fireTiktokTracker(
    'ViewContent',
    {
      content_category: contentCategory,
      content_id: contentId,
      content_name: contentName,
      content_type: 'product',
      price: price && price * 0.01,
      value: price && price * 0.01,
    },
    email,
  );
};

export const fireTiktokCheckoutAddCart = (
  { contentCategory, contentId, currency, price, quantity },
  email,
) => {
  fireTiktokTracker(
    'AddToCart',
    {
      content_category: contentCategory,
      content_id: contentId,
      content_type: 'product',
      currency,
      price: price && price * 0.01,
      quantity,
      value: price && price * 0.01,
    },
    email,
  );
};

export const fireTiktokCheckoutPlaceOrder = (
  { contentCategory, contentId, currency, price, quantity, value },
  email,
) => {
  fireTiktokTracker(
    'PlaceAnOrder',
    {
      content_category: contentCategory,
      content_id: contentId,
      content_type: 'product',
      currency,
      price: price && price * 0.01,
      quantity,
      value: value && value * 0.01,
    },
    email,
  );
};

export const fireTiktokCheckoutPurchase = (
  { contentCategory, contentId, currency, price, quantity, value },
  email,
) => {
  fireTiktokTracker(
    'CompletePayment',
    {
      content_category: contentCategory,
      content_id: contentId,
      content_type: 'product',
      currency,
      price: price && price * 0.01,
      quantity,
      value: value && value * 0.01,
    },
    email,
  );
};
